export const bucketNumber = (number: number, buckets: number[]): number => {
  for (const bucket of buckets) {
    if (number <= bucket) {
      return bucket;
    }
  }
  return buckets[buckets.length - 1] || 0;
};
